import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { Component, default as React } from 'react';
import { globalStyles as styles } from '../style/gstheme';
import SystemMaintenance from './SystemMaintenance';
import SystemMessageReplay from './SystemMessageReplay';
import { UserConsumer } from '../providers/UserProvider';

class SystemControl extends Component {

  render() {

    return (
      <div style={{ paddingRight: 30 }}>
        <UserConsumer>
          {({ user }) => {
            return <Grid container spacing={2} classes={
              {
                "spacing-xs-2": this.props.classes.fullGrid
              }
            }>
              <Grid item xs={12} md={6}>
                <SystemMaintenance user={user} />
              </Grid>
              <Grid item xs={12} md={6}>
                <SystemMessageReplay />
              </Grid>
            </Grid>;
          }}
        </UserConsumer>
      </div>
    );
  }
}

SystemControl.propTypes = {
  classes: PropTypes.object
};

export default withStyles(styles)(SystemControl);